<div class="custom-modal-container">
  <div class="custom-modal-container-content primary">
    <div (click)="onClose()" class="close-button">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>
    <i class="modal-icon">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-timeout"></use>
      </svg>
    </i>
    <div class="content-container">
      <h2 class="modal-title" translate>{{ 'Your session has timed out.' | translate }}</h2>
      <p class="modal-paragraph" translate>
        {{ 'To return to your session select the button in the email that initiated the session to continue from where you left off.' | translate }}
      </p>
      <div class="button-container">
        <a class="primary-button" (click)="onClose()">{{ 'Close' | translate }}</a>
      </div>
    </div>
  </div>
</div>
